import React, { FC } from 'react';
import * as S from '../styled';
import SearchProductCard from '@components/entities/search/components/product-card';
import { ProductsCardDTO } from '@api/generated-api';

interface IProductList {
	products: ProductsCardDTO[];
	onProductClick(): void;
}

const ProductList: FC<IProductList> = ({ products, onProductClick }) => {
	if (!products.length) {
		return null;
	}

	return (
		<S.ProductList>
			{products.slice(0, 4).map((product) => (
				<SearchProductCard
					key={product.id}
					product={product}
					onProductClick={onProductClick}
				/>
			))}
		</S.ProductList>
	);
};

export default ProductList;
